var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.0051C2 11.6504 2.15617 11.2856 2.41645 11.0424L9.2254 4.41545C9.51692 4.13173 9.85008 4 10.1832 4C10.9537 4 11.4951 4.53705 11.4951 5.23623C11.4951 5.62128 11.3285 5.92527 11.089 6.16846L8.72566 8.47878L6.09162 10.8296L8.43415 10.708H20.6257C21.4482 10.708 22 11.235 22 12.0051C22 12.7752 21.4482 13.3021 20.6257 13.3021H8.43415L6.09162 13.1704L8.72566 15.5313L11.089 17.8315C11.3285 18.0747 11.4951 18.3787 11.4951 18.7638C11.4951 19.4731 10.9537 20 10.1832 20C9.85008 20 9.52733 19.8683 9.24623 19.5947L2.41645 12.9677C2.15617 12.7144 2 12.3597 2 12.0051Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.c27fba31b789e40b01e270783a93415e.svg";
export { ForwardRef as ReactComponent };